$(function () {

    $(document).ready(function () {

        // offset sub navs
        var subNavs = $('.header__nav ul.dropdown-menu');
        var headerHeight = $('.header__nav').height();
        subNavs.css('top', headerHeight);

        // handle the scrolling and setting the background color
        $(window).scroll(function () {
            if ($(window).scrollTop() > 40) {
                $('.navbar').addClass('hovered-in');
                $('.navbar').addClass('hovered', 150, 'linear').addClass('shadow-sm');
            } else {
                // only remove the class if the user isn't hovered over it currently
                if ($('.navbar:hover').length == 0) {
                    $('.navbar').removeClass('hovered-in');
                    $('.navbar').removeClass('hovered', 50).removeClass('shadow-sm');
                }

                if ($('.ze-mobile-brand').css('display') !== 'none') {
                    $('.navbar').removeClass('hovered-in');
                    $('.navbar').removeClass('hovered', 50).removeClass('shadow-sm');
                }
            }
        })

        // handle the hover in and out functionality and set the background color
        $('header').hover(function () {
            if ($(window).scrollTop() <= 40) {
                $('.navbar').addClass('hovered-in');
                $('.navbar').addClass('hovered', 150, 'linear').addClass('shadow-sm');
            }
        }, function () {
            if ($(window).scrollTop() <= 40) {
                $('.navbar').removeClass('hovered-in');
                $('.navbar').removeClass('hovered', 50).removeClass('shadow-sm');
            }
        });
    });


    // mobile functionality

    $('#nav-icon-x').click(function () {
        $(this).toggleClass('open');

        var logo = $('.ze-mobile-brand').children('img');
        $('.header__nav').toggleClass('mobile-open');

        // make the mobile nav bar transparent again.
        if ($(window).scrollTop() <= 40) {
            $('.navbar').removeClass('hovered-in');
            $('.navbar').removeClass('hovered', 50).removeClass('shadow-sm');
        }

        // set the header image if opened
        if ($(this).hasClass('open')) {
            logo.attr('src', '/bundles/images/ZE_logo_full_color.svg');
        }
        else {
            logo.attr('src', '/bundles/images/ZE_logo_white.svg');
        }
    });

    // determining if short text should be displayed on resize and page load
    $(window).resize(function () {
        UpdateNavText();        
    });

    $(document).ready(function () {
        UpdateNavText();
    });
});

function UpdateNavText() {
    var navLinks = $('.nav-link');
    navLinks.each(function () {
        var shortText = $(this).find('.short-text');

        if (shortText.length > 0) {
            var ogText = $(this).find('.og-text');

            // temporarily show the og text to determine the height
            ogText.show();
            shortText.hide();

            var navItemHeight = $(this).height();
            var textHeight = ogText.height();

            if (textHeight > navItemHeight) {
                ogText.hide();
                shortText.show();
            }

        }
    });
}